<template>
    <div>
        <public-head title="校考题库"></public-head>
        <div class="main">
            <div v-for="(item,index) in detailData.question_list" :key="index">
                <div class="bank-con" @click="goDetail(item)">
                    <div class="subject" :style="{color:item.tags_color}">{{item.tags}}</div>
                    <div class="sub-con">{{item.title}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../../components/publicHead";
import { httpPost } from "../../../../axios/index";
export default {
    data() {
        return {
            detailData: []
        };
    },
    created() {},
    methods: {
        // 进入详情
        goDetail(e) {
           
            this.$router.push({
                path: "/fenlei/schoolSubjectDetail",
                query: {
                    id: e.id
                }
            });
        },
        show(e) {
            isshow = e;
        },
        // 获取专业介绍列表
        fetchSchoolDetail(sid) {
            httpPost("/classifie/school_details", {
                sid: sid
            }).then(res => {
              
                if (res.code === 1) {
                    this.detailData = res.list;
                }
            });
        }
    },
    mounted() {
        this.fetchSchoolDetail(this.$route.query.sid);
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.main {
    height: 100%;
    margin-top: 46px;
}
.bank-con {
    /* height: 90rpx; */
    border-bottom: 1px solid #ccc;
    padding: 0.75rem 0.9375rem;
    box-sizing: border-box;
}
.subject {
    width: 2.1875rem;
    height: 1rem;
    border-radius: 1px 5px 1px 5px;
    border: 1px solid #fe7666;
    background: #fed2cd;
    display: inline;
    font-size: 0.9375rem;
}
.sub-con {
    display: inline;
    font-size: 1rem;
}
</style>